/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class IotextranetClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * cancleExtranet
     * @param input input
     * @return OK
     */
    cancleExtranet(input: CloseExtranetDTO): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/client/cancle-extranet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCancleExtranet(_response);
        });
    }

    protected processCancleExtranet(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }
}

export class ExtranetClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * addVirtualChannelCloseRecord
     * @param recordDto recordDto
     * @return OK
     */
    addVirtualChannelCloseRecord(recordDto: VirtualChannelCloseRecordDto): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/client/iot-device/add-virtual-channel-close-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddVirtualChannelCloseRecord(_response);
        });
    }

    protected processAddVirtualChannelCloseRecord(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * closeSession
     * @param closeSessionDto closeSessionDto
     * @return OK
     */
    closeSession(closeSessionDto: CloseSessionDto): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/client/iot-device/close-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(closeSessionDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCloseSession(_response);
        });
    }

    protected processCloseSession(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * updateDeviceCodeStatus
     * @param deviceStatusDto deviceStatusDto
     * @return OK
     */
    updateDeviceCodeStatus(deviceStatusDto: DeviceStatusDto): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/client/iot-device/update-device-code-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceStatusDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateDeviceCodeStatus(_response);
        });
    }

    protected processUpdateDeviceCodeStatus(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }
}

export class ConnectionRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 反馈诊断结果
     * @param inDto inDto
     * @return OK
     */
    addRecord(inDto: DiagnosticRecordsDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/connection-record/add-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddRecord(_response);
        });
    }

    protected processAddRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * export
     * @param input input
     * @return OK
     */
    export(input: DiagnosticRecordsPageDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/connection-record/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询远程诊断记录
     * @param input input
     * @return OK
     */
    getPage(input: DiagnosticRecordsPageDTO): Promise<PagedResultVOOfDiagnosticRecordsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/connection-record/get-page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<PagedResultVOOfDiagnosticRecordsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfDiagnosticRecordsVO.fromJS(resultData200) : new PagedResultVOOfDiagnosticRecordsVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfDiagnosticRecordsVO>(<any>null);
    }
}

export class DeviceServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * findDeviceExtranetState
     * @param gatewayCode gatewayCode
     * @return OK
     */
    findDeviceExtranetState(gatewayCode: string): Promise<DeviceStateVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/device/findDeviceExtranetState?";
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindDeviceExtranetState(_response);
        });
    }

    protected processFindDeviceExtranetState(response: AxiosResponse): Promise<DeviceStateVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeviceStateVO.fromJS(resultData200) : new DeviceStateVO();
            return result200;
        }
        return Promise.resolve<DeviceStateVO>(<any>null);
    }

    /**
     * findDeviceStateList
     * @param input input
     * @return OK
     */
    findDeviceStateList(input: FindDeviceStateListDto): Promise<DeviceStateVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/device/findDeviceStateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindDeviceStateList(_response);
        });
    }

    protected processFindDeviceStateList(response: AxiosResponse): Promise<DeviceStateVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceStateVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceStateVO[]>(<any>null);
    }
}

export class DockingExtranetServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 远程连接服务连接认证
     * @param request request
     * @return OK
     */
    certificationRequest(request: CertificationRequest): Promise<CertificationResponse> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/docking-extranet/certification-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCertificationRequest(_response);
        });
    }

    protected processCertificationRequest(response: AxiosResponse): Promise<CertificationResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CertificationResponse.fromJS(resultData200) : new CertificationResponse();
            return result200;
        }
        return Promise.resolve<CertificationResponse>(<any>null);
    }

    /**
     * 远程连接服务网关认证
     * @param request request
     * @return OK
     */
    iotLoginRequest(request: IotLoginRequest): Promise<IotLoginResponse> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/docking-extranet/iot-login-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processIotLoginRequest(_response);
        });
    }

    protected processIotLoginRequest(response: AxiosResponse): Promise<IotLoginResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IotLoginResponse.fromJS(resultData200) : new IotLoginResponse();
            return result200;
        }
        return Promise.resolve<IotLoginResponse>(<any>null);
    }
}

export class ExtranetConfigServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 清空设备配置
     * @param id (optional) 设备配置id
     * @return OK
     */
    clearDeviceConfig(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/clear-device-config?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClearDeviceConfig(_response);
        });
    }

    protected processClearDeviceConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * deleteDeviceConfig
     * @param deviceConfigId deviceConfigId
     * @return OK
     */
    deleteDeviceConfig(deviceConfigId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/delete-device-config?";
        if (deviceConfigId === undefined || deviceConfigId === null)
            throw new Error("The parameter 'deviceConfigId' must be defined and cannot be null.");
        else
            url_ += "deviceConfigId=" + encodeURIComponent("" + deviceConfigId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteDeviceConfig(_response);
        });
    }

    protected processDeleteDeviceConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询设备配置
     * @param deviceId (optional) 工位设备id
     * @return OK
     */
    getDeviceConfig(deviceId: string | null | undefined): Promise<DeviceConfigVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/get-device-config?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceConfig(_response);
        });
    }

    protected processGetDeviceConfig(response: AxiosResponse): Promise<DeviceConfigVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeviceConfigVO.fromJS(resultData200) : new DeviceConfigVO();
            return result200;
        }
        return Promise.resolve<DeviceConfigVO>(<any>null);
    }

    /**
     * 获取连接数据
     * @param deviceId deviceId
     * @param gatewayCode gatewayCode
     * @return OK
     */
    getDeviceConfigData(deviceId: string, gatewayCode: string): Promise<QueryExportDataVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/get-device-config-data?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined and cannot be null.");
        else
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceConfigData(_response);
        });
    }

    protected processGetDeviceConfigData(response: AxiosResponse): Promise<QueryExportDataVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? QueryExportDataVO.fromJS(resultData200) : new QueryExportDataVO();
            return result200;
        }
        return Promise.resolve<QueryExportDataVO>(<any>null);
    }

    /**
     * 查询设备配置
     * @param deviceId (optional) 工位设备id
     * @return OK
     */
    getDeviceConfigList(deviceId: string | null | undefined): Promise<DeviceConfigVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/get-device-config-list?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceConfigList(_response);
        });
    }

    protected processGetDeviceConfigList(response: AxiosResponse): Promise<DeviceConfigVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceConfigVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceConfigVO[]>(<any>null);
    }

    /**
     * getExtranetConfig
     * @param deviceId deviceId
     * @param gatewayCode gatewayCode
     * @return OK
     */
    getExtranetConfig(deviceId: string, gatewayCode: string): Promise<DeviceConfigDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/get-extranet-config?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined and cannot be null.");
        else
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetExtranetConfig(_response);
        });
    }

    protected processGetExtranetConfig(response: AxiosResponse): Promise<DeviceConfigDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeviceConfigDto.fromJS(resultData200) : new DeviceConfigDto();
            return result200;
        }
        return Promise.resolve<DeviceConfigDto>(<any>null);
    }

    /**
     * 查询当前用户配置
     * @return OK
     */
    getUserConfig(): Promise<UserConfigVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/get-user-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserConfig(_response);
        });
    }

    protected processGetUserConfig(response: AxiosResponse): Promise<UserConfigVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? UserConfigVO.fromJS(resultData200) : new UserConfigVO();
            return result200;
        }
        return Promise.resolve<UserConfigVO>(<any>null);
    }

    /**
     * 保存设备配置
     * @param saveDeviceConfigDTO saveDeviceConfigDTO
     * @return OK
     */
    saveDeviceConfig(saveDeviceConfigDTO: SaveDeviceConfigDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/save-device-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDeviceConfigDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveDeviceConfig(_response);
        });
    }

    protected processSaveDeviceConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 保存连接数据
     * @param gatewayConfigDataDTO gatewayConfigDataDTO
     * @return OK
     */
    saveDeviceConfigData(gatewayConfigDataDTO: GatewayConfigDataDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/save-device-config-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gatewayConfigDataDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveDeviceConfigData(_response);
        });
    }

    protected processSaveDeviceConfigData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * saveExtranetConfig
     * @param deviceConfig deviceConfig
     * @return OK
     */
    saveExtranetConfig(deviceConfig: DeviceConfigDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/save-extranet-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceConfig);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveExtranetConfig(_response);
        });
    }

    protected processSaveExtranetConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 保存用户配置
     * @param userVirtualIp (optional) 用户PC虚拟IP
     * @return OK
     */
    saveUserConfig(userVirtualIp: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-config/save-user-config?";
        if (userVirtualIp !== undefined)
            url_ += "userVirtualIp=" + encodeURIComponent("" + userVirtualIp) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveUserConfig(_response);
        });
    }

    protected processSaveUserConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ExtranetParamSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getCurrentExtranetParamSetting
     * @return OK
     */
    getCurrentExtranetParamSetting(): Promise<ExtranetParamSetting> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-param-setting/getCurrentExtranetParamSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurrentExtranetParamSetting(_response);
        });
    }

    protected processGetCurrentExtranetParamSetting(response: AxiosResponse): Promise<ExtranetParamSetting> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ExtranetParamSetting.fromJS(resultData200) : new ExtranetParamSetting();
            return result200;
        }
        return Promise.resolve<ExtranetParamSetting>(<any>null);
    }

    /**
     * getExtranetParamSetting
     * @param tenantId tenantId
     * @return OK
     */
    getExtranetParamSetting(tenantId: string): Promise<ExtranetParamSetting> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-param-setting/getExtranetParamSetting?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetExtranetParamSetting(_response);
        });
    }

    protected processGetExtranetParamSetting(response: AxiosResponse): Promise<ExtranetParamSetting> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ExtranetParamSetting.fromJS(resultData200) : new ExtranetParamSetting();
            return result200;
        }
        return Promise.resolve<ExtranetParamSetting>(<any>null);
    }

    /**
     * saveExtranetParamSetting
     * @param input input
     * @return OK
     */
    saveExtranetParamSetting(input: ExtranetParamSetting): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-param-setting/saveExtranetParamSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveExtranetParamSetting(_response);
        });
    }

    protected processSaveExtranetParamSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ExtranetProtocolServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除远程连接协议
     * @return OK
     */
    deleteExtranetProtocol(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-protocol/delete-extranet-protocol";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteExtranetProtocol(_response);
        });
    }

    protected processDeleteExtranetProtocol(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * getExtranetProtocol
     * @return OK
     */
    getExtranetProtocol(): Promise<ExtranetProtocolVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-protocol/get-extranet-protocol";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetExtranetProtocol(_response);
        });
    }

    protected processGetExtranetProtocol(response: AxiosResponse): Promise<ExtranetProtocolVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ExtranetProtocolVO.fromJS(resultData200) : new ExtranetProtocolVO();
            return result200;
        }
        return Promise.resolve<ExtranetProtocolVO>(<any>null);
    }

    /**
     * 新增或修改一个远程连接协议
     * @param extranetProtocolDTO extranetProtocolDTO
     * @return OK
     */
    submitExtranetProtocol(extranetProtocolDTO: ExtranetProtocolDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet-protocol/submit-extranet-protocol";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(extranetProtocolDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmitExtranetProtocol(_response);
        });
    }

    protected processSubmitExtranetProtocol(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class ExtranetServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 开始远程连接
     * @param input input
     * @return OK
     */
    beginExtranet(input: BeginExtranetDTO): Promise<BeginExtranetVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/begin-extranet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBeginExtranet(_response);
        });
    }

    protected processBeginExtranet(response: AxiosResponse): Promise<BeginExtranetVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BeginExtranetVO.fromJS(resultData200) : new BeginExtranetVO();
            return result200;
        }
        return Promise.resolve<BeginExtranetVO>(<any>null);
    }

    /**
     * 使用连接码开始远程连接
     * @param extranetCode (optional) 连接码
     * @return OK
     */
    beginExtranetWithCode(extranetCode: string | null | undefined): Promise<BeginExtranetVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/begin-extranet-with-code?";
        if (extranetCode !== undefined)
            url_ += "extranetCode=" + encodeURIComponent("" + extranetCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBeginExtranetWithCode(_response);
        });
    }

    protected processBeginExtranetWithCode(response: AxiosResponse): Promise<BeginExtranetVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BeginExtranetVO.fromJS(resultData200) : new BeginExtranetVO();
            return result200;
        }
        return Promise.resolve<BeginExtranetVO>(<any>null);
    }

    /**
     * 关闭远程连接
     * @param input input
     * @return OK
     */
    closeExtranet(input: CloseExtranetDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/close-extranet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCloseExtranet(_response);
        });
    }

    protected processCloseExtranet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * closeSession
     * @param connectCode connectCode
     * @return OK
     */
    closeSession(connectCode: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/close-session/{connectCode}";
        if (connectCode === undefined || connectCode === null)
            throw new Error("The parameter 'connectCode' must be defined.");
        url_ = url_.replace("{connectCode}", encodeURIComponent("" + connectCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCloseSession(_response);
        });
    }

    protected processCloseSession(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询设备详情
     * @param input input
     * @return OK
     */
    findDeviceList(input: PageDeviceDetailsDTO): Promise<PagedResultVOOfDeviceDetailsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/findDeviceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindDeviceList(_response);
        });
    }

    protected processFindDeviceList(response: AxiosResponse): Promise<PagedResultVOOfDeviceDetailsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfDeviceDetailsVO.fromJS(resultData200) : new PagedResultVOOfDeviceDetailsVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfDeviceDetailsVO>(<any>null);
    }

    /**
     * 查询单个设备详情
     * @param workStationId workStationId
     * @return OK
     */
    getDeviceDetails(workStationId: string): Promise<DeviceDetailsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/get-device-details/{workStationId}";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceDetails(_response);
        });
    }

    protected processGetDeviceDetails(response: AxiosResponse): Promise<DeviceDetailsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeviceDetailsVO.fromJS(resultData200) : new DeviceDetailsVO();
            return result200;
        }
        return Promise.resolve<DeviceDetailsVO>(<any>null);
    }

    /**
     * getDeviceListByGateway
     * @param gatewayId gatewayId
     * @return OK
     */
    getDeviceListByGateway(gatewayId: string): Promise<DeviceDetailsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/get-device-list-by-gateway?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceListByGateway(_response);
        });
    }

    protected processGetDeviceListByGateway(response: AxiosResponse): Promise<DeviceDetailsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDetailsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DeviceDetailsVO[]>(<any>null);
    }

    /**
     * 分页查询设备详情
     * @param input input
     * @return OK
     */
    pageDeviceDetails(input: PageDeviceDetailsDTO): Promise<PagedResultVOOfDeviceDetailsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/page-device-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageDeviceDetails(_response);
        });
    }

    protected processPageDeviceDetails(response: AxiosResponse): Promise<PagedResultVOOfDeviceDetailsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfDeviceDetailsVO.fromJS(resultData200) : new PagedResultVOOfDeviceDetailsVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfDeviceDetailsVO>(<any>null);
    }

    /**
     * 分页查询工位组设备详情
     * @param input input
     * @return OK
     */
    pageDeviceDetailsByGroup(input: PageDeviceDetailsByGroupDTO): Promise<PagedResultVOOfDeviceDetailsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/page-device-details-by-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageDeviceDetailsByGroup(_response);
        });
    }

    protected processPageDeviceDetailsByGroup(response: AxiosResponse): Promise<PagedResultVOOfDeviceDetailsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfDeviceDetailsVO.fromJS(resultData200) : new PagedResultVOOfDeviceDetailsVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfDeviceDetailsVO>(<any>null);
    }

    /**
     * 停止失败的远程连接
     * @param input input
     * @return OK
     */
    stopFailedExtranet(input: CloseExtranetDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/stop-failed-extranet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStopFailedExtranet(_response);
        });
    }

    protected processStopFailedExtranet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * workingExtranet
     * @param gatewayCode (optional) 
     * @param gatewayId (optional) 
     * @return OK
     */
    workingExtranet(gatewayCode: string | null | undefined, gatewayId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/extranet/workingExtranet?";
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        if (gatewayId !== undefined)
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkingExtranet(_response);
        });
    }

    protected processWorkingExtranet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class GatewayConfigServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * saveGatewayConfig
     * @param gatewayConfigDTOList gatewayConfigDTOList
     * @return OK
     */
    saveGatewayConfig(gatewayConfigDTOList: PushGatewayConfigDTO[]): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/gateway-config/save-gateway-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gatewayConfigDTOList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveGatewayConfig(_response);
        });
    }

    protected processSaveGatewayConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改网关虚拟ip
     * @param updateVirtualIpDTO updateVirtualIpDTO
     * @return OK
     */
    saveViratualIp(updateVirtualIpDTO: UpdateVirtualIpDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/gateway-config/save-viratual-ip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateVirtualIpDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveViratualIp(_response);
        });
    }

    protected processSaveViratualIp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class VirtualChannelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * findConfig
     * @param code code
     * @return OK
     */
    findConfig(code: string): Promise<VirtualChannelDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-extranetv2')+ "/virtualChannel/findConfig?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindConfig(_response);
        });
    }

    protected processFindConfig(response: AxiosResponse): Promise<VirtualChannelDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? VirtualChannelDto.fromJS(resultData200) : new VirtualChannelDto();
            return result200;
        }
        return Promise.resolve<VirtualChannelDto>(<any>null);
    }
}

export class BeginExtranetDTO implements IBeginExtranetDTO {
    /** 过期时间 */
    expireTime!: string | undefined;
    /** 设备Id[工位id] */
    workStationIds!: number[];

    constructor(data?: IBeginExtranetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.workStationIds = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.expireTime = data["expireTime"];
            if (data["workStationIds"] && data["workStationIds"].constructor === Array) {
                this.workStationIds = [] as any;
                for (let item of data["workStationIds"])
                    this.workStationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BeginExtranetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BeginExtranetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expireTime"] = this.expireTime;
        if (this.workStationIds && this.workStationIds.constructor === Array) {
            data["workStationIds"] = [];
            for (let item of this.workStationIds)
                data["workStationIds"].push(item);
        }
        return data; 
    }
}

export interface IBeginExtranetDTO {
    /** 过期时间 */
    expireTime: string | undefined;
    /** 设备Id[工位id] */
    workStationIds: number[];
}

export class BeginExtranetVO implements IBeginExtranetVO {
    extranetCode!: string | undefined;
    sessionId!: string | undefined;

    constructor(data?: IBeginExtranetVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extranetCode = data["extranetCode"];
            this.sessionId = data["sessionId"];
        }
    }

    static fromJS(data: any): BeginExtranetVO {
        data = typeof data === 'object' ? data : {};
        let result = new BeginExtranetVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extranetCode"] = this.extranetCode;
        data["sessionId"] = this.sessionId;
        return data; 
    }
}

export interface IBeginExtranetVO {
    extranetCode: string | undefined;
    sessionId: string | undefined;
}

export class CertificationRequest implements ICertificationRequest {
    args!: CertificationRequestMetadata | undefined;
    cmd!: string | undefined;
    node!: string | undefined;
    sequence!: string | undefined;
    timestamp!: string | undefined;

    constructor(data?: ICertificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.args = data["args"] ? CertificationRequestMetadata.fromJS(data["args"]) : <any>undefined;
            this.cmd = data["cmd"];
            this.node = data["node"];
            this.sequence = data["sequence"];
            this.timestamp = data["timestamp"];
        }
    }

    static fromJS(data: any): CertificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["args"] = this.args ? this.args.toJSON() : <any>undefined;
        data["cmd"] = this.cmd;
        data["node"] = this.node;
        data["sequence"] = this.sequence;
        data["timestamp"] = this.timestamp;
        return data; 
    }
}

export interface ICertificationRequest {
    args: CertificationRequestMetadata | undefined;
    cmd: string | undefined;
    node: string | undefined;
    sequence: string | undefined;
    timestamp: string | undefined;
}

export class CertificationRequestMetadata implements ICertificationRequestMetadata {
    id!: string | undefined;
    protocol!: string | undefined;
    version!: string | undefined;

    constructor(data?: ICertificationRequestMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.protocol = data["protocol"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): CertificationRequestMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationRequestMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["protocol"] = this.protocol;
        data["version"] = this.version;
        return data; 
    }
}

export interface ICertificationRequestMetadata {
    id: string | undefined;
    protocol: string | undefined;
    version: string | undefined;
}

export class CertificationResponse implements ICertificationResponse {
    cmd!: string | undefined;
    node!: string | undefined;
    result!: CertificationResponseResult | undefined;
    sequence!: string | undefined;
    timestamp!: string | undefined;

    constructor(data?: ICertificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cmd = data["cmd"];
            this.node = data["node"];
            this.result = data["result"] ? CertificationResponseResult.fromJS(data["result"]) : <any>undefined;
            this.sequence = data["sequence"];
            this.timestamp = data["timestamp"];
        }
    }

    static fromJS(data: any): CertificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cmd"] = this.cmd;
        data["node"] = this.node;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["sequence"] = this.sequence;
        data["timestamp"] = this.timestamp;
        return data; 
    }
}

export interface ICertificationResponse {
    cmd: string | undefined;
    node: string | undefined;
    result: CertificationResponseResult | undefined;
    sequence: string | undefined;
    timestamp: string | undefined;
}

export class CertificationResponseResult implements ICertificationResponseResult {
    config!: IotExtranetConfig[] | undefined;
    expired!: string | undefined;
    id!: string | undefined;
    postcode!: string | undefined;
    protocol!: string | undefined;
    verified!: boolean | undefined;
    version!: string | undefined;
    virtualIp!: string | undefined;

    constructor(data?: ICertificationResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["config"] && data["config"].constructor === Array) {
                this.config = [] as any;
                for (let item of data["config"])
                    this.config!.push(IotExtranetConfig.fromJS(item));
            }
            this.expired = data["expired"];
            this.id = data["id"];
            this.postcode = data["postcode"];
            this.protocol = data["protocol"];
            this.verified = data["verified"];
            this.version = data["version"];
            this.virtualIp = data["virtualIp"];
        }
    }

    static fromJS(data: any): CertificationResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.config && this.config.constructor === Array) {
            data["config"] = [];
            for (let item of this.config)
                data["config"].push(item.toJSON());
        }
        data["expired"] = this.expired;
        data["id"] = this.id;
        data["postcode"] = this.postcode;
        data["protocol"] = this.protocol;
        data["verified"] = this.verified;
        data["version"] = this.version;
        data["virtualIp"] = this.virtualIp;
        return data; 
    }
}

export interface ICertificationResponseResult {
    config: IotExtranetConfig[] | undefined;
    expired: string | undefined;
    id: string | undefined;
    postcode: string | undefined;
    protocol: string | undefined;
    verified: boolean | undefined;
    version: string | undefined;
    virtualIp: string | undefined;
}

export class CloseExtranetDTO implements ICloseExtranetDTO {
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    /** 连接会话id */
    sessionId!: string;

    constructor(data?: ICloseExtranetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.sessionId = data["sessionId"];
        }
    }

    static fromJS(data: any): CloseExtranetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CloseExtranetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["sessionId"] = this.sessionId;
        return data; 
    }
}

export interface ICloseExtranetDTO {
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    /** 连接会话id */
    sessionId: string;
}

export class CloseSessionDto implements ICloseSessionDto {
    /** 连接码 */
    extranetCode!: string | undefined;

    constructor(data?: ICloseSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extranetCode = data["extranetCode"];
        }
    }

    static fromJS(data: any): CloseSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extranetCode"] = this.extranetCode;
        return data; 
    }
}

export interface ICloseSessionDto {
    /** 连接码 */
    extranetCode: string | undefined;
}

export class DeviceConfigDto implements IDeviceConfigDto {
    deviceDataList!: DeviceDataConfigDto[] | undefined;
    deviceGateway!: DeviceGatewayConfigDto | undefined;
    deviceId!: string | undefined;
    deviceLocal!: DeviceLocalConfigDto | undefined;

    constructor(data?: IDeviceConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["deviceDataList"] && data["deviceDataList"].constructor === Array) {
                this.deviceDataList = [] as any;
                for (let item of data["deviceDataList"])
                    this.deviceDataList!.push(DeviceDataConfigDto.fromJS(item));
            }
            this.deviceGateway = data["deviceGateway"] ? DeviceGatewayConfigDto.fromJS(data["deviceGateway"]) : <any>undefined;
            this.deviceId = data["deviceId"];
            this.deviceLocal = data["deviceLocal"] ? DeviceLocalConfigDto.fromJS(data["deviceLocal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.deviceDataList && this.deviceDataList.constructor === Array) {
            data["deviceDataList"] = [];
            for (let item of this.deviceDataList)
                data["deviceDataList"].push(item.toJSON());
        }
        data["deviceGateway"] = this.deviceGateway ? this.deviceGateway.toJSON() : <any>undefined;
        data["deviceId"] = this.deviceId;
        data["deviceLocal"] = this.deviceLocal ? this.deviceLocal.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDeviceConfigDto {
    deviceDataList: DeviceDataConfigDto[] | undefined;
    deviceGateway: DeviceGatewayConfigDto | undefined;
    deviceId: string | undefined;
    deviceLocal: DeviceLocalConfigDto | undefined;
}

export class DeviceConfigVO implements IDeviceConfigVO {
    /** 设备真实Ip */
    deviceIp!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 设备虚拟Ip */
    mapIp!: string | undefined;
    /** 可用最大端口 */
    maxPort!: number | undefined;
    /** 可用最小端口 */
    minPort!: number | undefined;
    /** 网关的网口Ip,网关所在的真实Ip */
    networkIp!: string | undefined;
    /** 用户层协议 */
    protocol!: string | undefined;
    /** 网关端虚拟网卡Ip */
    virtualIp!: string | undefined;
    /** 工位主键id */
    workStationId!: string | undefined;

    constructor(data?: IDeviceConfigVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceIp = data["deviceIp"];
            this.id = data["id"];
            this.mapIp = data["mapIp"];
            this.maxPort = data["maxPort"];
            this.minPort = data["minPort"];
            this.networkIp = data["networkIp"];
            this.protocol = data["protocol"];
            this.virtualIp = data["virtualIp"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DeviceConfigVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConfigVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIp"] = this.deviceIp;
        data["id"] = this.id;
        data["mapIp"] = this.mapIp;
        data["maxPort"] = this.maxPort;
        data["minPort"] = this.minPort;
        data["networkIp"] = this.networkIp;
        data["protocol"] = this.protocol;
        data["virtualIp"] = this.virtualIp;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDeviceConfigVO {
    /** 设备真实Ip */
    deviceIp: string | undefined;
    /** id */
    id: string | undefined;
    /** 设备虚拟Ip */
    mapIp: string | undefined;
    /** 可用最大端口 */
    maxPort: number | undefined;
    /** 可用最小端口 */
    minPort: number | undefined;
    /** 网关的网口Ip,网关所在的真实Ip */
    networkIp: string | undefined;
    /** 用户层协议 */
    protocol: string | undefined;
    /** 网关端虚拟网卡Ip */
    virtualIp: string | undefined;
    /** 工位主键id */
    workStationId: string | undefined;
}

export class DeviceDataConfigDto implements IDeviceDataConfigDto {
    deviceName!: string | undefined;
    ipClone!: boolean | undefined;
    lanIp!: string | undefined;
    linkGatewayIp!: string | undefined;
    virtualIp!: string | undefined;
    physicalName!: string| undefined;

    constructor(data?: IDeviceDataConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceName = data["deviceName"];
            this.ipClone = data["ipClone"];
            this.lanIp = data["lanIp"];
            this.linkGatewayIp = data["linkGatewayIp"];
            this.virtualIp = data["virtualIp"];
            this.physicalName = data["physicalName"];
        }
    }

    static fromJS(data: any): DeviceDataConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDataConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["ipClone"] = this.ipClone;
        data["lanIp"] = this.lanIp;
        data["linkGatewayIp"] = this.linkGatewayIp;
        data["virtualIp"] = this.virtualIp;
        data["physicalName"] = this.physicalName;
        return data; 
    }
}

export interface IDeviceDataConfigDto {
    deviceName: string | undefined;
    ipClone: boolean | undefined;
    lanIp: string | undefined;
    linkGatewayIp: string | undefined;
    virtualIp: string | undefined;
}

export class DeviceDetailsVO implements IDeviceDetailsVO {
    avatar!: string | undefined;
    /** 工位编号 */
    code!: string | undefined;
    /** 所属客户 */
    customerName!: string | undefined;
    /** 机床型号 */
    equipmentModel!: string | undefined;
    /** 设备序列号 */
    equipmentSerialNumber!: string | undefined;
    /** 诊断码过期时间 */
    expiredDate!: Date | undefined;
    /** 诊断通道状态 true 在线 | false 离线 | null 不存在 */
    extranetAppStatus!: boolean | undefined;
    /** 连接码 */
    extranetCode!: string | undefined;
    /** 诊断网关SN */
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 工位名称 */
    name!: string | undefined;
    /** 会话id */
    sessionId!: string | undefined;
    /** 工位类型 */
    type!: number | undefined;
    /** 是否可以进行远程连接 0 未就绪| 1 就绪| 2 连接中 */
    userVisibleStatus!: number | undefined;

    constructor(data?: IDeviceDetailsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.code = data["code"];
            this.customerName = data["customerName"];
            this.equipmentModel = data["equipmentModel"];
            this.equipmentSerialNumber = data["equipmentSerialNumber"];
            this.expiredDate = data["expiredDate"] ? new Date(data["expiredDate"].toString()) : <any>undefined;
            this.extranetAppStatus = data["extranetAppStatus"];
            this.extranetCode = data["extranetCode"];
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.id = data["id"];
            this.name = data["name"];
            this.sessionId = data["sessionId"];
            this.type = data["type"];
            this.userVisibleStatus = data["userVisibleStatus"];
        }
    }

    static fromJS(data: any): DeviceDetailsVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDetailsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["code"] = this.code;
        data["customerName"] = this.customerName;
        data["equipmentModel"] = this.equipmentModel;
        data["equipmentSerialNumber"] = this.equipmentSerialNumber;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["extranetAppStatus"] = this.extranetAppStatus;
        data["extranetCode"] = this.extranetCode;
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["sessionId"] = this.sessionId;
        data["type"] = this.type;
        data["userVisibleStatus"] = this.userVisibleStatus;
        return data; 
    }
}

export interface IDeviceDetailsVO {
    avatar: string | undefined;
    /** 工位编号 */
    code: string | undefined;
    /** 所属客户 */
    customerName: string | undefined;
    /** 机床型号 */
    equipmentModel: string | undefined;
    /** 设备序列号 */
    equipmentSerialNumber: string | undefined;
    /** 诊断码过期时间 */
    expiredDate: Date | undefined;
    /** 诊断通道状态 true 在线 | false 离线 | null 不存在 */
    extranetAppStatus: boolean | undefined;
    /** 连接码 */
    extranetCode: string | undefined;
    /** 诊断网关SN */
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    /** id */
    id: string | undefined;
    /** 工位名称 */
    name: string | undefined;
    /** 会话id */
    sessionId: string | undefined;
    /** 工位类型 */
    type: number | undefined;
    /** 是否可以进行远程连接 0 未就绪| 1 就绪| 2 连接中 */
    userVisibleStatus: number | undefined;
}

export class DeviceGatewayConfigDto implements IDeviceGatewayConfigDto {
    gatewayCode!: string | undefined;
    itemList!: DeviceGatewayItemDto[] | undefined;
    virtualIp!: string | undefined;

    constructor(data?: IDeviceGatewayConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            if (data["itemList"] && data["itemList"].constructor === Array) {
                this.itemList = [] as any;
                for (let item of data["itemList"])
                    this.itemList!.push(DeviceGatewayItemDto.fromJS(item));
            }
            this.virtualIp = data["virtualIp"];
        }
    }

    static fromJS(data: any): DeviceGatewayConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceGatewayConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        if (this.itemList && this.itemList.constructor === Array) {
            data["itemList"] = [];
            for (let item of this.itemList)
                data["itemList"].push(item.toJSON());
        }
        data["virtualIp"] = this.virtualIp;
        return data; 
    }
}

export interface IDeviceGatewayConfigDto {
    gatewayCode: string | undefined;
    itemList: DeviceGatewayItemDto[] | undefined;
    virtualIp: string | undefined;
}

export class DeviceGatewayItemDto implements IDeviceGatewayItemDto {
    ip!: string | undefined;
    name!: string | undefined;

    constructor(data?: IDeviceGatewayItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ip = data["ip"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): DeviceGatewayItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceGatewayItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ip"] = this.ip;
        data["name"] = this.name;
        return data; 
    }
}

export interface IDeviceGatewayItemDto {
    ip: string | undefined;
    name: string | undefined;
}

export class DeviceLocalConfigDto implements IDeviceLocalConfigDto {
    virtualIp!: string | undefined;

    constructor(data?: IDeviceLocalConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.virtualIp = data["virtualIp"];
        }
    }

    static fromJS(data: any): DeviceLocalConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceLocalConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["virtualIp"] = this.virtualIp;
        return data; 
    }
}

export interface IDeviceLocalConfigDto {
    virtualIp: string | undefined;
}

export class DeviceStateVO implements IDeviceStateVO {
    connectCode!: string | undefined;
    exist!: boolean | undefined;
    gatewayId!: string | undefined;
    states!: string | undefined;
    userVisibleStatus!: number | undefined;

    constructor(data?: IDeviceStateVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectCode = data["connectCode"];
            this.exist = data["exist"];
            this.gatewayId = data["gatewayId"];
            this.states = data["states"];
            this.userVisibleStatus = data["userVisibleStatus"];
        }
    }

    static fromJS(data: any): DeviceStateVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStateVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectCode"] = this.connectCode;
        data["exist"] = this.exist;
        data["gatewayId"] = this.gatewayId;
        data["states"] = this.states;
        data["userVisibleStatus"] = this.userVisibleStatus;
        return data; 
    }
}

export interface IDeviceStateVO {
    connectCode: string | undefined;
    exist: boolean | undefined;
    gatewayId: string | undefined;
    states: string | undefined;
    userVisibleStatus: number | undefined;
}

export class DeviceStatusDto implements IDeviceStatusDto {
    connectCode!: string | undefined;
    /** 网关code */
    gatewayCode!: string | undefined;
    recordVirtualLink!: boolean | undefined;
    /** 状态ready,notready,working */
    status!: string | undefined;
    virtualLinkState!: string | undefined;

    constructor(data?: IDeviceStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectCode = data["connectCode"];
            this.gatewayCode = data["gatewayCode"];
            this.recordVirtualLink = data["recordVirtualLink"];
            this.status = data["status"];
            this.virtualLinkState = data["virtualLinkState"];
        }
    }

    static fromJS(data: any): DeviceStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectCode"] = this.connectCode;
        data["gatewayCode"] = this.gatewayCode;
        data["recordVirtualLink"] = this.recordVirtualLink;
        data["status"] = this.status;
        data["virtualLinkState"] = this.virtualLinkState;
        return data; 
    }
}

export interface IDeviceStatusDto {
    connectCode: string | undefined;
    /** 网关code */
    gatewayCode: string | undefined;
    recordVirtualLink: boolean | undefined;
    /** 状态ready,notready,working */
    status: string | undefined;
    virtualLinkState: string | undefined;
}

export class DevicesVO implements IDevicesVO {
    /** 设备真实地址 */
    laddress!: string | undefined;
    name!: string | undefined;
    options!: any | undefined;
    title!: string | undefined;
    /** 设备虚拟地址 */
    vaddress!: string | undefined;

    constructor(data?: IDevicesVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.laddress = data["laddress"];
            this.name = data["name"];
            this.options = data["options"];
            this.title = data["title"];
            this.vaddress = data["vaddress"];
        }
    }

    static fromJS(data: any): DevicesVO {
        data = typeof data === 'object' ? data : {};
        let result = new DevicesVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laddress"] = this.laddress;
        data["name"] = this.name;
        data["options"] = this.options;
        data["title"] = this.title;
        data["vaddress"] = this.vaddress;
        return data; 
    }
}

export interface IDevicesVO {
    /** 设备真实地址 */
    laddress: string | undefined;
    name: string | undefined;
    options: any | undefined;
    title: string | undefined;
    /** 设备虚拟地址 */
    vaddress: string | undefined;
}

export class DiagnosticRecordsDTO implements IDiagnosticRecordsDTO {
    /** 诊断提交人 */
    diagnosticPerson!: string | undefined;
    /** 诊断操作类型[可不填，或填3：手动中止诊断]，后续扩展可用 */
    diagnosticType!: number | undefined;
    /** 故障描述 */
    faultDesc!: string | undefined;
    /** 处理意见 */
    handleOpinion!: string | undefined;
    /** 工位id */
    workStationId!: string;

    constructor(data?: IDiagnosticRecordsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagnosticPerson = data["diagnosticPerson"];
            this.diagnosticType = data["diagnosticType"];
            this.faultDesc = data["faultDesc"];
            this.handleOpinion = data["handleOpinion"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DiagnosticRecordsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticRecordsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticPerson"] = this.diagnosticPerson;
        data["diagnosticType"] = this.diagnosticType;
        data["faultDesc"] = this.faultDesc;
        data["handleOpinion"] = this.handleOpinion;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDiagnosticRecordsDTO {
    /** 诊断提交人 */
    diagnosticPerson: string | undefined;
    /** 诊断操作类型[可不填，或填3：手动中止诊断]，后续扩展可用 */
    diagnosticType: number | undefined;
    /** 故障描述 */
    faultDesc: string | undefined;
    /** 处理意见 */
    handleOpinion: string | undefined;
    /** 工位id */
    workStationId: string;
}

export class DiagnosticRecordsPageDTO implements IDiagnosticRecordsPageDTO {
    /** 连接账户 */
    connectAccount!: string | undefined;
    /** 所属客户 */
    customerId!: string | undefined;
    /** 设备编号 */
    deviceCode!: string | undefined;
    /** 设备Id */
    deviceId!: string | undefined;
    /** 设备类型 */
    deviceType!: string | undefined;
    /** 设备类型Id */
    deviceTypeId!: string | undefined;
    /** 开始时间 */
    end!: Date | undefined;
    pageRequestDTO!: PageRequestDTO | undefined;
    /** 结束时间 */
    start!: Date | undefined;

    constructor(data?: IDiagnosticRecordsPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectAccount = data["connectAccount"];
            this.customerId = data["customerId"];
            this.deviceCode = data["deviceCode"];
            this.deviceId = data["deviceId"];
            this.deviceType = data["deviceType"];
            this.deviceTypeId = data["deviceTypeId"];
            this.end = data["end"] ? new Date(data["end"].toString()) : <any>undefined;
            this.pageRequestDTO = data["pageRequestDTO"] ? PageRequestDTO.fromJS(data["pageRequestDTO"]) : <any>undefined;
            this.start = data["start"] ? new Date(data["start"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DiagnosticRecordsPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticRecordsPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectAccount"] = this.connectAccount;
        data["customerId"] = this.customerId;
        data["deviceCode"] = this.deviceCode;
        data["deviceId"] = this.deviceId;
        data["deviceType"] = this.deviceType;
        data["deviceTypeId"] = this.deviceTypeId;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["pageRequestDTO"] = this.pageRequestDTO ? this.pageRequestDTO.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDiagnosticRecordsPageDTO {
    /** 连接账户 */
    connectAccount: string | undefined;
    /** 所属客户 */
    customerId: string | undefined;
    /** 设备编号 */
    deviceCode: string | undefined;
    /** 设备Id */
    deviceId: string | undefined;
    /** 设备类型 */
    deviceType: string | undefined;
    /** 设备类型Id */
    deviceTypeId: string | undefined;
    /** 开始时间 */
    end: Date | undefined;
    pageRequestDTO: PageRequestDTO | undefined;
    /** 结束时间 */
    start: Date | undefined;
}

export class DiagnosticRecordsVO implements IDiagnosticRecordsVO {
    /** 连接账户 */
    connectAccount!: string | undefined;
    /** 连接时间 */
    connectTime!: Date | undefined;
    /** 所属客户 */
    customer!: string | undefined;
    /** 设备编号 */
    deviceCode!: string | undefined;
    /** 设备类型 */
    deviceType!: string | undefined;
    /** 提交人 */
    diagnosticPerson!: string | undefined;
    /** 连接类型 */
    diagnosticType!: string | undefined;
    /** 故障描述 */
    faultDesc!: string | undefined;
    /** 处理意见 */
    handleOpinion!: string | undefined;
    /** 提交时间 */
    operationTime!: Date | undefined;
    workStationId!: string | undefined;

    constructor(data?: IDiagnosticRecordsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectAccount = data["connectAccount"];
            this.connectTime = data["connectTime"] ? new Date(data["connectTime"].toString()) : <any>undefined;
            this.customer = data["customer"];
            this.deviceCode = data["deviceCode"];
            this.deviceType = data["deviceType"];
            this.diagnosticPerson = data["diagnosticPerson"];
            this.diagnosticType = data["diagnosticType"];
            this.faultDesc = data["faultDesc"];
            this.handleOpinion = data["handleOpinion"];
            this.operationTime = data["operationTime"] ? new Date(data["operationTime"].toString()) : <any>undefined;
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): DiagnosticRecordsVO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticRecordsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectAccount"] = this.connectAccount;
        data["connectTime"] = this.connectTime ? this.connectTime.toISOString() : <any>undefined;
        data["customer"] = this.customer;
        data["deviceCode"] = this.deviceCode;
        data["deviceType"] = this.deviceType;
        data["diagnosticPerson"] = this.diagnosticPerson;
        data["diagnosticType"] = this.diagnosticType;
        data["faultDesc"] = this.faultDesc;
        data["handleOpinion"] = this.handleOpinion;
        data["operationTime"] = this.operationTime ? this.operationTime.toISOString() : <any>undefined;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IDiagnosticRecordsVO {
    /** 连接账户 */
    connectAccount: string | undefined;
    /** 连接时间 */
    connectTime: Date | undefined;
    /** 所属客户 */
    customer: string | undefined;
    /** 设备编号 */
    deviceCode: string | undefined;
    /** 设备类型 */
    deviceType: string | undefined;
    /** 提交人 */
    diagnosticPerson: string | undefined;
    /** 连接类型 */
    diagnosticType: string | undefined;
    /** 故障描述 */
    faultDesc: string | undefined;
    /** 处理意见 */
    handleOpinion: string | undefined;
    /** 提交时间 */
    operationTime: Date | undefined;
    workStationId: string | undefined;
}

export class ExtranetParamSetting implements IExtranetParamSetting {
    deleteEnable!: boolean | undefined;
    editEnable!: boolean | undefined;
    max!: number | undefined;
    tenantId!: string | undefined;

    constructor(data?: IExtranetParamSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deleteEnable = data["deleteEnable"];
            this.editEnable = data["editEnable"];
            this.max = data["max"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): ExtranetParamSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ExtranetParamSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleteEnable"] = this.deleteEnable;
        data["editEnable"] = this.editEnable;
        data["max"] = this.max;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IExtranetParamSetting {
    deleteEnable: boolean | undefined;
    editEnable: boolean | undefined;
    max: number | undefined;
    tenantId: string | undefined;
}

export class ExtranetProtocolDTO implements IExtranetProtocolDTO {
    /** 协议类型，多个以 , 分割 */
    protocolType!: string[] | undefined;

    constructor(data?: IExtranetProtocolDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["protocolType"] && data["protocolType"].constructor === Array) {
                this.protocolType = [] as any;
                for (let item of data["protocolType"])
                    this.protocolType!.push(item);
            }
        }
    }

    static fromJS(data: any): ExtranetProtocolDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtranetProtocolDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.protocolType && this.protocolType.constructor === Array) {
            data["protocolType"] = [];
            for (let item of this.protocolType)
                data["protocolType"].push(item);
        }
        return data; 
    }
}

export interface IExtranetProtocolDTO {
    /** 协议类型，多个以 , 分割 */
    protocolType: string[] | undefined;
}

export class ExtranetProtocolVO implements IExtranetProtocolVO {
    /** 协议类型，多个以 , 分割 */
    protocolType!: string[] | undefined;

    constructor(data?: IExtranetProtocolVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["protocolType"] && data["protocolType"].constructor === Array) {
                this.protocolType = [] as any;
                for (let item of data["protocolType"])
                    this.protocolType!.push(item);
            }
        }
    }

    static fromJS(data: any): ExtranetProtocolVO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtranetProtocolVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.protocolType && this.protocolType.constructor === Array) {
            data["protocolType"] = [];
            for (let item of this.protocolType)
                data["protocolType"].push(item);
        }
        return data; 
    }
}

export interface IExtranetProtocolVO {
    /** 协议类型，多个以 , 分割 */
    protocolType: string[] | undefined;
}

export class FindDeviceStateListDto implements IFindDeviceStateListDto {
    gatewayIdList!: string[] | undefined;

    constructor(data?: IFindDeviceStateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["gatewayIdList"] && data["gatewayIdList"].constructor === Array) {
                this.gatewayIdList = [] as any;
                for (let item of data["gatewayIdList"])
                    this.gatewayIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): FindDeviceStateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FindDeviceStateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.gatewayIdList && this.gatewayIdList.constructor === Array) {
            data["gatewayIdList"] = [];
            for (let item of this.gatewayIdList)
                data["gatewayIdList"].push(item);
        }
        return data; 
    }
}

export interface IFindDeviceStateListDto {
    gatewayIdList: string[] | undefined;
}

export class GatewayConfigDataDTO implements IGatewayConfigDataDTO {
    deviceId!: string | undefined;
    gatewayCode!: string | undefined;
    ipClone!: boolean | undefined;
    queryExportData!: QueryExportDataVO | undefined;

    constructor(data?: IGatewayConfigDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.gatewayCode = data["gatewayCode"];
            this.ipClone = data["ipClone"];
            this.queryExportData = data["queryExportData"] ? QueryExportDataVO.fromJS(data["queryExportData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GatewayConfigDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayConfigDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["gatewayCode"] = this.gatewayCode;
        data["ipClone"] = this.ipClone;
        data["queryExportData"] = this.queryExportData ? this.queryExportData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGatewayConfigDataDTO {
    deviceId: string | undefined;
    gatewayCode: string | undefined;
    ipClone: boolean | undefined;
    queryExportData: QueryExportDataVO | undefined;
}

export class IotExtranetConfig implements IIotExtranetConfig {
    id!: string | undefined;
    link!: IotExtranetLink[] | undefined;
    networkIp!: string | undefined;
    postcode!: string | undefined;
    virtualIp!: string | undefined;

    constructor(data?: IIotExtranetConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["link"] && data["link"].constructor === Array) {
                this.link = [] as any;
                for (let item of data["link"])
                    this.link!.push(IotExtranetLink.fromJS(item));
            }
            this.networkIp = data["networkIp"];
            this.postcode = data["postcode"];
            this.virtualIp = data["virtualIp"];
        }
    }

    static fromJS(data: any): IotExtranetConfig {
        data = typeof data === 'object' ? data : {};
        let result = new IotExtranetConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.link && this.link.constructor === Array) {
            data["link"] = [];
            for (let item of this.link)
                data["link"].push(item.toJSON());
        }
        data["networkIp"] = this.networkIp;
        data["postcode"] = this.postcode;
        data["virtualIp"] = this.virtualIp;
        return data; 
    }
}

export interface IIotExtranetConfig {
    id: string | undefined;
    link: IotExtranetLink[] | undefined;
    networkIp: string | undefined;
    postcode: string | undefined;
    virtualIp: string | undefined;
}

export class IotExtranetLink implements IIotExtranetLink {
    deviceIp!: string | undefined;
    mapIp!: string | undefined;
    ports!: string | undefined;
    protocol!: string | undefined;

    constructor(data?: IIotExtranetLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceIp = data["deviceIp"];
            this.mapIp = data["mapIp"];
            this.ports = data["ports"];
            this.protocol = data["protocol"];
        }
    }

    static fromJS(data: any): IotExtranetLink {
        data = typeof data === 'object' ? data : {};
        let result = new IotExtranetLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIp"] = this.deviceIp;
        data["mapIp"] = this.mapIp;
        data["ports"] = this.ports;
        data["protocol"] = this.protocol;
        return data; 
    }
}

export interface IIotExtranetLink {
    deviceIp: string | undefined;
    mapIp: string | undefined;
    ports: string | undefined;
    protocol: string | undefined;
}

export class IotLoginRequest implements IIotLoginRequest {
    args!: IotLoginRequestMetadata | undefined;
    cmd!: string | undefined;
    node!: string | undefined;
    sequence!: string | undefined;
    timestamp!: string | undefined;

    constructor(data?: IIotLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.args = data["args"] ? IotLoginRequestMetadata.fromJS(data["args"]) : <any>undefined;
            this.cmd = data["cmd"];
            this.node = data["node"];
            this.sequence = data["sequence"];
            this.timestamp = data["timestamp"];
        }
    }

    static fromJS(data: any): IotLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IotLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["args"] = this.args ? this.args.toJSON() : <any>undefined;
        data["cmd"] = this.cmd;
        data["node"] = this.node;
        data["sequence"] = this.sequence;
        data["timestamp"] = this.timestamp;
        return data; 
    }
}

export interface IIotLoginRequest {
    args: IotLoginRequestMetadata | undefined;
    cmd: string | undefined;
    node: string | undefined;
    sequence: string | undefined;
    timestamp: string | undefined;
}

export class IotLoginRequestMetadata implements IIotLoginRequestMetadata {
    id!: string | undefined;
    protocol!: string | undefined;
    version!: string | undefined;

    constructor(data?: IIotLoginRequestMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.protocol = data["protocol"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): IotLoginRequestMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new IotLoginRequestMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["protocol"] = this.protocol;
        data["version"] = this.version;
        return data; 
    }
}

export interface IIotLoginRequestMetadata {
    id: string | undefined;
    protocol: string | undefined;
    version: string | undefined;
}

export class IotLoginResponse implements IIotLoginResponse {
    cmd!: string | undefined;
    node!: string | undefined;
    result!: IotLoginResponseResult | undefined;
    sequence!: string | undefined;
    timestamp!: string | undefined;

    constructor(data?: IIotLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cmd = data["cmd"];
            this.node = data["node"];
            this.result = data["result"] ? IotLoginResponseResult.fromJS(data["result"]) : <any>undefined;
            this.sequence = data["sequence"];
            this.timestamp = data["timestamp"];
        }
    }

    static fromJS(data: any): IotLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IotLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cmd"] = this.cmd;
        data["node"] = this.node;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["sequence"] = this.sequence;
        data["timestamp"] = this.timestamp;
        return data; 
    }
}

export interface IIotLoginResponse {
    cmd: string | undefined;
    node: string | undefined;
    result: IotLoginResponseResult | undefined;
    sequence: string | undefined;
    timestamp: string | undefined;
}

export class IotLoginResponseResult implements IIotLoginResponseResult {
    id!: string | undefined;
    protocol!: string | undefined;
    verified!: boolean | undefined;
    version!: string | undefined;

    constructor(data?: IIotLoginResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.protocol = data["protocol"];
            this.verified = data["verified"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): IotLoginResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new IotLoginResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["protocol"] = this.protocol;
        data["verified"] = this.verified;
        data["version"] = this.version;
        return data; 
    }
}

export interface IIotLoginResponseResult {
    id: string | undefined;
    protocol: string | undefined;
    verified: boolean | undefined;
    version: string | undefined;
}

export class LocalInterface implements ILocalInterface {
    address!: string | undefined;
    name!: string | undefined;
    title!: string | undefined;
    type!: string | undefined;
    vlinks!: VlinksVO[] | undefined;

    constructor(data?: ILocalInterface) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.name = data["name"];
            this.title = data["title"];
            this.type = data["type"];
            if (data["vlinks"] && data["vlinks"].constructor === Array) {
                this.vlinks = [] as any;
                for (let item of data["vlinks"])
                    this.vlinks!.push(VlinksVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalInterface {
        data = typeof data === 'object' ? data : {};
        let result = new LocalInterface();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["name"] = this.name;
        data["title"] = this.title;
        data["type"] = this.type;
        if (this.vlinks && this.vlinks.constructor === Array) {
            data["vlinks"] = [];
            for (let item of this.vlinks)
                data["vlinks"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILocalInterface {
    address: string | undefined;
    name: string | undefined;
    title: string | undefined;
    type: string | undefined;
    vlinks: VlinksVO[] | undefined;
}

export class LocalRemoteOfLocalInterface implements ILocalRemoteOfLocalInterface {
    interfaces!: LocalInterface[] | undefined;
    title!: string | undefined;

    constructor(data?: ILocalRemoteOfLocalInterface) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["interfaces"] && data["interfaces"].constructor === Array) {
                this.interfaces = [] as any;
                for (let item of data["interfaces"])
                    this.interfaces!.push(LocalInterface.fromJS(item));
            }
            this.title = data["title"];
        }
    }

    static fromJS(data: any): LocalRemoteOfLocalInterface {
        data = typeof data === 'object' ? data : {};
        let result = new LocalRemoteOfLocalInterface();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.interfaces && this.interfaces.constructor === Array) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item.toJSON());
        }
        data["title"] = this.title;
        return data; 
    }
}

export interface ILocalRemoteOfLocalInterface {
    interfaces: LocalInterface[] | undefined;
    title: string | undefined;
}

export class LocalRemoteOfRemoteInterface implements ILocalRemoteOfRemoteInterface {
    interfaces!: RemoteInterface[] | undefined;
    title!: string | undefined;

    constructor(data?: ILocalRemoteOfRemoteInterface) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["interfaces"] && data["interfaces"].constructor === Array) {
                this.interfaces = [] as any;
                for (let item of data["interfaces"])
                    this.interfaces!.push(RemoteInterface.fromJS(item));
            }
            this.title = data["title"];
        }
    }

    static fromJS(data: any): LocalRemoteOfRemoteInterface {
        data = typeof data === 'object' ? data : {};
        let result = new LocalRemoteOfRemoteInterface();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.interfaces && this.interfaces.constructor === Array) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item.toJSON());
        }
        data["title"] = this.title;
        return data; 
    }
}

export interface ILocalRemoteOfRemoteInterface {
    interfaces: RemoteInterface[] | undefined;
    title: string | undefined;
}

export class PageDeviceDetailsByGroupDTO implements IPageDeviceDetailsByGroupDTO {
    ascs!: string | undefined;
    current!: number | undefined;
    descs!: string | undefined;
    filter!: string | undefined;
    /** 工位组集合 */
    groups!: string[] | undefined;
    size!: number | undefined;

    constructor(data?: IPageDeviceDetailsByGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ascs = data["ascs"];
            this.current = data["current"];
            this.descs = data["descs"];
            this.filter = data["filter"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [] as any;
                for (let item of data["groups"])
                    this.groups!.push(item);
            }
            this.size = data["size"];
        }
    }

    static fromJS(data: any): PageDeviceDetailsByGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageDeviceDetailsByGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascs"] = this.ascs;
        data["current"] = this.current;
        data["descs"] = this.descs;
        data["filter"] = this.filter;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["size"] = this.size;
        return data; 
    }
}

export interface IPageDeviceDetailsByGroupDTO {
    ascs: string | undefined;
    current: number | undefined;
    descs: string | undefined;
    filter: string | undefined;
    /** 工位组集合 */
    groups: string[] | undefined;
    size: number | undefined;
}

export class PageDeviceDetailsDTO implements IPageDeviceDetailsDTO {
    /** 区域列表 */
    areaNameList!: string[] | undefined;
    ascs!: string | undefined;
    current!: number | undefined;
    /** 客户Id */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    descs!: string | undefined;
    /** 远程连接状态,0:未就绪, 1:就绪, 2:工作中 */
    extranetState!: number | undefined;
    filter!: string | undefined;
    size!: number | undefined;

    constructor(data?: IPageDeviceDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["areaNameList"] && data["areaNameList"].constructor === Array) {
                this.areaNameList = [] as any;
                for (let item of data["areaNameList"])
                    this.areaNameList!.push(item);
            }
            this.ascs = data["ascs"];
            this.current = data["current"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.descs = data["descs"];
            this.extranetState = data["extranetState"];
            this.filter = data["filter"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): PageDeviceDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageDeviceDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.areaNameList && this.areaNameList.constructor === Array) {
            data["areaNameList"] = [];
            for (let item of this.areaNameList)
                data["areaNameList"].push(item);
        }
        data["ascs"] = this.ascs;
        data["current"] = this.current;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["descs"] = this.descs;
        data["extranetState"] = this.extranetState;
        data["filter"] = this.filter;
        data["size"] = this.size;
        return data; 
    }
}

export interface IPageDeviceDetailsDTO {
    /** 区域列表 */
    areaNameList: string[] | undefined;
    ascs: string | undefined;
    current: number | undefined;
    /** 客户Id */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    descs: string | undefined;
    /** 远程连接状态,0:未就绪, 1:就绪, 2:工作中 */
    extranetState: number | undefined;
    filter: string | undefined;
    size: number | undefined;
}

export class PageRequestDTO implements IPageRequestDTO {
    ascs!: string | undefined;
    current!: number | undefined;
    descs!: string | undefined;
    filter!: string | undefined;
    size!: number | undefined;

    constructor(data?: IPageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ascs = data["ascs"];
            this.current = data["current"];
            this.descs = data["descs"];
            this.filter = data["filter"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): PageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascs"] = this.ascs;
        data["current"] = this.current;
        data["descs"] = this.descs;
        data["filter"] = this.filter;
        data["size"] = this.size;
        return data; 
    }
}

export interface IPageRequestDTO {
    ascs: string | undefined;
    current: number | undefined;
    descs: string | undefined;
    filter: string | undefined;
    size: number | undefined;
}

export class PagedResultVOOfDeviceDetailsVO implements IPagedResultVOOfDeviceDetailsVO {
    items!: DeviceDetailsVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfDeviceDetailsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(DeviceDetailsVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfDeviceDetailsVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfDeviceDetailsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfDeviceDetailsVO {
    items: DeviceDetailsVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfDiagnosticRecordsVO implements IPagedResultVOOfDiagnosticRecordsVO {
    items!: DiagnosticRecordsVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfDiagnosticRecordsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(DiagnosticRecordsVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfDiagnosticRecordsVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfDiagnosticRecordsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfDiagnosticRecordsVO {
    items: DiagnosticRecordsVO[] | undefined;
    totalCount: number | undefined;
}

export class PushGatewayConfigDTO implements IPushGatewayConfigDTO {
    /** 网关编号 */
    gatewayCode!: string | undefined;
    /** 接口名称 */
    interfaceName!: string | undefined;
    /** [接口类型(eth.ipv4网口   (待定)串口)] */
    interfaceType!: string | undefined;
    /** 网关真实ip */
    networkIp!: string | undefined;

    constructor(data?: IPushGatewayConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.interfaceName = data["interfaceName"];
            this.interfaceType = data["interfaceType"];
            this.networkIp = data["networkIp"];
        }
    }

    static fromJS(data: any): PushGatewayConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PushGatewayConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["interfaceName"] = this.interfaceName;
        data["interfaceType"] = this.interfaceType;
        data["networkIp"] = this.networkIp;
        return data; 
    }
}

export interface IPushGatewayConfigDTO {
    /** 网关编号 */
    gatewayCode: string | undefined;
    /** 接口名称 */
    interfaceName: string | undefined;
    /** [接口类型(eth.ipv4网口   (待定)串口)] */
    interfaceType: string | undefined;
    /** 网关真实ip */
    networkIp: string | undefined;
}

export class QueryExportDataVO implements IQueryExportDataVO {
    ipClone!: boolean | undefined;
    local!: LocalRemoteOfLocalInterface | undefined;
    remote!: LocalRemoteOfRemoteInterface | undefined;

    constructor(data?: IQueryExportDataVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ipClone = data["ipClone"];
            this.local = data["local"] ? LocalRemoteOfLocalInterface.fromJS(data["local"]) : <any>undefined;
            this.remote = data["remote"] ? LocalRemoteOfRemoteInterface.fromJS(data["remote"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QueryExportDataVO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryExportDataVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipClone"] = this.ipClone;
        data["local"] = this.local ? this.local.toJSON() : <any>undefined;
        data["remote"] = this.remote ? this.remote.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IQueryExportDataVO {
    ipClone: boolean | undefined;
    local: LocalRemoteOfLocalInterface | undefined;
    remote: LocalRemoteOfRemoteInterface | undefined;
}

/** 返回信息 */
export class ROfboolean implements IROfboolean {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: boolean | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfboolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfboolean {
        data = typeof data === 'object' ? data : {};
        let result = new ROfboolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfboolean {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: boolean | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class RemoteInterface implements IRemoteInterface {
    address!: string | undefined;
    devices!: DevicesVO[] | undefined;
    name!: string | undefined;
    title!: string | undefined;
    type!: string | undefined;

    constructor(data?: IRemoteInterface) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            if (data["devices"] && data["devices"].constructor === Array) {
                this.devices = [] as any;
                for (let item of data["devices"])
                    this.devices!.push(DevicesVO.fromJS(item));
            }
            this.name = data["name"];
            this.title = data["title"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): RemoteInterface {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteInterface();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        if (this.devices && this.devices.constructor === Array) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["title"] = this.title;
        data["type"] = this.type;
        return data; 
    }
}

export interface IRemoteInterface {
    address: string | undefined;
    devices: DevicesVO[] | undefined;
    name: string | undefined;
    title: string | undefined;
    type: string | undefined;
}

export class SaveDeviceConfigDTO implements ISaveDeviceConfigDTO {
    /** 设备真实Ip */
    deviceIp!: string;
    id!: string | undefined;
    /** 远程接口名称 */
    interfaceName!: string | undefined;
    /** 设备虚拟Ip */
    mapIp!: string;
    /** 可用最大端口 */
    maxPort!: number | undefined;
    /** 可用最小端口 */
    minPort!: number | undefined;
    /** 网关的网口Ip,网关所在的真实Ip */
    networkIp!: string;
    /** 用户层协议 */
    protocol!: string;
    /** 备注 */
    remark!: string | undefined;
    /** 网关端虚拟网卡Ip */
    virtualIp!: string;
    /** 工位主键id */
    workStationId!: string;

    constructor(data?: ISaveDeviceConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceIp = data["deviceIp"];
            this.id = data["id"];
            this.interfaceName = data["interfaceName"];
            this.mapIp = data["mapIp"];
            this.maxPort = data["maxPort"];
            this.minPort = data["minPort"];
            this.networkIp = data["networkIp"];
            this.protocol = data["protocol"];
            this.remark = data["remark"];
            this.virtualIp = data["virtualIp"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): SaveDeviceConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDeviceConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIp"] = this.deviceIp;
        data["id"] = this.id;
        data["interfaceName"] = this.interfaceName;
        data["mapIp"] = this.mapIp;
        data["maxPort"] = this.maxPort;
        data["minPort"] = this.minPort;
        data["networkIp"] = this.networkIp;
        data["protocol"] = this.protocol;
        data["remark"] = this.remark;
        data["virtualIp"] = this.virtualIp;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface ISaveDeviceConfigDTO {
    /** 设备真实Ip */
    deviceIp: string;
    id: string | undefined;
    /** 远程接口名称 */
    interfaceName: string | undefined;
    /** 设备虚拟Ip */
    mapIp: string;
    /** 可用最大端口 */
    maxPort: number | undefined;
    /** 可用最小端口 */
    minPort: number | undefined;
    /** 网关的网口Ip,网关所在的真实Ip */
    networkIp: string;
    /** 用户层协议 */
    protocol: string;
    /** 备注 */
    remark: string | undefined;
    /** 网关端虚拟网卡Ip */
    virtualIp: string;
    /** 工位主键id */
    workStationId: string;
}

export class UpdateVirtualIpDTO implements IUpdateVirtualIpDTO {
    /** 网关编号 */
    gatewayCode!: string | undefined;
    /** 虚拟ip */
    virtualIp!: string | undefined;

    constructor(data?: IUpdateVirtualIpDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.virtualIp = data["virtualIp"];
        }
    }

    static fromJS(data: any): UpdateVirtualIpDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVirtualIpDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["virtualIp"] = this.virtualIp;
        return data; 
    }
}

export interface IUpdateVirtualIpDTO {
    /** 网关编号 */
    gatewayCode: string | undefined;
    /** 虚拟ip */
    virtualIp: string | undefined;
}

export class UserConfigVO implements IUserConfigVO {
    /** 用户PC虚拟ip */
    userVirtualIp!: string | undefined;

    constructor(data?: IUserConfigVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userVirtualIp = data["userVirtualIp"];
        }
    }

    static fromJS(data: any): UserConfigVO {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfigVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userVirtualIp"] = this.userVirtualIp;
        return data; 
    }
}

export interface IUserConfigVO {
    /** 用户PC虚拟ip */
    userVirtualIp: string | undefined;
}

export class VirtualChannelCloseRecordDto implements IVirtualChannelCloseRecordDto {
    connectCode!: string | undefined;
    gatewayCode!: string | undefined;

    constructor(data?: IVirtualChannelCloseRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectCode = data["connectCode"];
            this.gatewayCode = data["gatewayCode"];
        }
    }

    static fromJS(data: any): VirtualChannelCloseRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualChannelCloseRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectCode"] = this.connectCode;
        data["gatewayCode"] = this.gatewayCode;
        return data; 
    }
}

export interface IVirtualChannelCloseRecordDto {
    connectCode: string | undefined;
    gatewayCode: string | undefined;
}

export class VirtualChannelDto implements IVirtualChannelDto {
    expires!: string | undefined;
    gatewayCode!: string | undefined;
    linkCode!: string | undefined;
    linkList!: VirtualChannelLinkDto[] | undefined;
    pcVirtualIp!: string | undefined;

    constructor(data?: IVirtualChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.expires = data["expires"];
            this.gatewayCode = data["gatewayCode"];
            this.linkCode = data["linkCode"];
            if (data["linkList"] && data["linkList"].constructor === Array) {
                this.linkList = [] as any;
                for (let item of data["linkList"])
                    this.linkList!.push(VirtualChannelLinkDto.fromJS(item));
            }
            this.pcVirtualIp = data["pcVirtualIp"];
        }
    }

    static fromJS(data: any): VirtualChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expires"] = this.expires;
        data["gatewayCode"] = this.gatewayCode;
        data["linkCode"] = this.linkCode;
        if (this.linkList && this.linkList.constructor === Array) {
            data["linkList"] = [];
            for (let item of this.linkList)
                data["linkList"].push(item.toJSON());
        }
        data["pcVirtualIp"] = this.pcVirtualIp;
        return data; 
    }
}

export interface IVirtualChannelDto {
    expires: string | undefined;
    gatewayCode: string | undefined;
    linkCode: string | undefined;
    linkList: VirtualChannelLinkDto[] | undefined;
    pcVirtualIp: string | undefined;
}

export class VirtualChannelLinkDto implements IVirtualChannelLinkDto {
    deviceIp!: string | undefined;
    deviceVirtualIp!: string | undefined;
    gatewayIp!: string | undefined;
    gatewayVirtualIp!: string | undefined;
    options!: string | undefined;

    constructor(data?: IVirtualChannelLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceIp = data["deviceIp"];
            this.deviceVirtualIp = data["deviceVirtualIp"];
            this.gatewayIp = data["gatewayIp"];
            this.gatewayVirtualIp = data["gatewayVirtualIp"];
            this.options = data["options"];
        }
    }

    static fromJS(data: any): VirtualChannelLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualChannelLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIp"] = this.deviceIp;
        data["deviceVirtualIp"] = this.deviceVirtualIp;
        data["gatewayIp"] = this.gatewayIp;
        data["gatewayVirtualIp"] = this.gatewayVirtualIp;
        data["options"] = this.options;
        return data; 
    }
}

export interface IVirtualChannelLinkDto {
    deviceIp: string | undefined;
    deviceVirtualIp: string | undefined;
    gatewayIp: string | undefined;
    gatewayVirtualIp: string | undefined;
    options: string | undefined;
}

export class VlinksVO implements IVlinksVO {
    /** 网关真实地址 */
    networkIp!: string | undefined;
    /** 设备真实地址 */
    toDevice!: string | undefined;
    /** 接口名称 */
    toInterface!: string | undefined;

    constructor(data?: IVlinksVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.networkIp = data["networkIp"];
            this.toDevice = data["toDevice"];
            this.toInterface = data["toInterface"];
        }
    }

    static fromJS(data: any): VlinksVO {
        data = typeof data === 'object' ? data : {};
        let result = new VlinksVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["networkIp"] = this.networkIp;
        data["toDevice"] = this.toDevice;
        data["toInterface"] = this.toInterface;
        return data; 
    }
}

export interface IVlinksVO {
    /** 网关真实地址 */
    networkIp: string | undefined;
    /** 设备真实地址 */
    toDevice: string | undefined;
    /** 接口名称 */
    toInterface: string | undefined;
}